// src/data/spokenPunctuation.js - Record 661 (Greg's test, 2026-10-12 15:04Z, claim text: "does it get punctuation I don't
// know if it gets punctuation I don't think it gets punctuation period exclamation point question mark"). The browser's
// speech recognition (desktop Chrome) does not turn spoken punctuation into marks. This does, for the words people say,
// and capitalises the start of each sentence. Pure; no browser API.

const MARKS = [
  [/\s*\b(?:new paragraph)\b\s*/gi, '\n\n'],
  [/\s*\b(?:new line|newline)\b\s*/gi, '\n'],
  [/\s*\b(?:question mark)\b/gi, '?'],
  [/\s*\b(?:exclamation (?:point|mark))\b/gi, '!'],
  [/\s*\b(?:full stop|period)\b/gi, '.'],
  [/\s*\bcomma\b/gi, ','],
  [/\s*\bcolon\b/gi, ':'],
  [/\s*\bsemicolon\b/gi, ';'],
];

export function applySpokenPunctuation(text) {
  let t = String(text || '');
  for (const [re, mark] of MARKS) t = t.replace(re, mark);
  t = t.replace(/([.!?,:;])(?=[A-Za-z0-9])/g, '$1 ');            // a space after a mark, before the next word
  t = t.replace(/(^|[.!?]\s+|\n\s*)([a-z])/g, (m, p, c) => p + c.toUpperCase());   // capitalise each sentence start
  t = t.replace(/\bi\b/g, 'I');                                    // the pronoun
  return t.replace(/[ \t]{2,}/g, ' ').trim();
}
